




















import { Component, Vue } from 'vue-property-decorator';
import FormHeader from '../headers/form-header/form-header.vue';

const ADMIN_PASSWORD = '33DFX';

@Component({
    components: {
        'form-header': FormHeader
    },
})
export default class AdminAuthView extends Vue {

  public mdInputText = '';
  public mdFieldClass = '';


  onSubmit(){
   if(this.mdInputText === ADMIN_PASSWORD ){
       localStorage.setItem('isAuth','true')
    this.$emit('onSucceed');
    } else {
        this.$emit('onFailed');
    }
  }
  

}
